<template>
  <div class="layout" style="height: 100%">
    <div class="app-flex">
      <user-menu v-if="!isMobile" />
      <div class="appMain">
        <center-head-menu v-if="isMobile"></center-head-menu>
        <div class="app-content">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UserMenu from "@/layout/UserMenu.vue";
import CenterHeadMenu from "@/layout/CenterHeadMenu.vue";
export default {
  components: {
    CenterHeadMenu,
    UserMenu
  },
  data() {
    return {
      isMobile: false
    }
  },
  mounted() {
    this.isMobile = window.innerWidth < 768;
  }
}
</script>
<style lang="scss" scoped>
.app-flex {
  display: flex;
  height: 100%;
}

.appMain {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  align-items: center;
  background-color: #F7F9FF;
  .app-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    height:100%;
    // padding-bottom: 50px;
  }
}
</style>
